<!-- <p>employee-attendance-report works!</p> -->
<div
  *ngIf="dataSourceWithIndex.length > 0"
  [ngClass]="{
    'employee-details-table-wrapper':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'employee-details-table-wrapper-mobile': screenSize == ScreenType.Mobile
  }"
>
  <div class="table-bottom">
    <button
      (click)="onPreviousButtonClick()"
      [disabled]="numberOfPreviousWeeks == 1"
      mat-raised-button
    >
      Previous Week
    </button>
    <button
      (click)="onNextButtonClick()"
      [disabled]="numberOfPreviousWeeks == totalEmployeeWeeks"
      mat-raised-button
    >
      Next Week
    </button>
    <button
      (click)="onCurrentButtonClick()"
      [disabled]="numberOfPreviousWeeks == totalEmployeeWeeks"
      mat-raised-button
    >
      Current Week
    </button>
    <button (click)="downloadAttendance()" mat-raised-button>Download Attendance</button>
  </div>
  <div class="employee-report-table-container">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef>No.</th>
        <td mat-cell *matCellDef="let element" style="font-weight: 500">
          {{ element.Index }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Sunday">
        <th
          [ngStyle]="todaysDay == 7 ? { 'font-weight': '900' } : {}"
          mat-header-cell
          *matHeaderCellDef
        >
          SUN <br /><span>{{
            currentWeekReport[6].date | date : "MMM dd"
          }}</span>
        </th>
        <td
          [ngClass]="{
            '': !currentWeekReport[6].valid,
            'a-status':
              !(
                currentWeekReport[6].valid &&
                element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][6]?.status
              ) && currentWeekReport[6].valid,
            'p-status':
              currentWeekReport[6].valid &&
              element.groupedEmployeeAttendanceLogWeeks &&
              element.groupedEmployeeAttendanceLogWeeks[
                numberOfPreviousWeeks - 1
              ][6]?.status
          }"
          [ngStyle]="{
            'font-weight': areDatesEqual(currentWeekReport[6].date)
              ? '900'
              : 'normal',
            'background-color': areDatesEqual(currentWeekReport[6].date)
              ? 'wheat'
              : 'transparent'
          }"
          mat-cell
          *matCellDef="let element"
        >
          {{
            currentWeekReport[6].valid
              ? element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][6]?.status
                ? "P"
                : "A"
              : "NA"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Monday">
        <th
          [ngStyle]="todaysDay == 1 ? { 'font-weight': '900' } : {}"
          mat-header-cell
          *matHeaderCellDef
        >
          MON <br /><span>{{
            currentWeekReport[0].date | date : "MMM dd"
          }}</span>
        </th>
        <td
          [ngClass]="{
            '': !currentWeekReport[0].valid,
            'a-status':
              !(
                currentWeekReport[0].valid &&
                element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][0]?.status
              ) && currentWeekReport[0].valid,
            'p-status':
              currentWeekReport[0].valid &&
              element.groupedEmployeeAttendanceLogWeeks &&
              element.groupedEmployeeAttendanceLogWeeks[
                numberOfPreviousWeeks - 1
              ][0]?.status
          }"
          [ngStyle]="{
            'font-weight': areDatesEqual(currentWeekReport[0].date)
              ? '900'
              : 'normal',
            'background-color': areDatesEqual(currentWeekReport[0].date)
              ? 'wheat'
              : 'transparent'
          }"
          mat-cell
          *matCellDef="let element"
        >
          {{
            currentWeekReport[0].valid
              ? element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][0]?.status
                ? "P"
                : "A"
              : "NA"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Tuesday">
        <th
          [ngStyle]="todaysDay == 2 ? { 'font-weight': '900' } : {}"
          mat-header-cell
          *matHeaderCellDef
        >
          TUE<br />
          <span>{{ currentWeekReport[1].date | date : "MMM dd" }}</span>
        </th>
        <td
          [ngClass]="{
            '': !currentWeekReport[1].valid,
            'a-status':
              !(
                currentWeekReport[1].valid &&
                element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][1]?.status
              ) && currentWeekReport[1].valid,
            'p-status':
              currentWeekReport[1].valid &&
              element.groupedEmployeeAttendanceLogWeeks &&
              element.groupedEmployeeAttendanceLogWeeks[
                numberOfPreviousWeeks - 1
              ][1]?.status
          }"
          [ngStyle]="{
            'font-weight': areDatesEqual(currentWeekReport[1].date)
              ? '900'
              : 'normal',
            'background-color': areDatesEqual(currentWeekReport[1].date)
              ? 'wheat'
              : 'transparent'
          }"
          mat-cell
          *matCellDef="let element"
        >
          {{
            currentWeekReport[1].valid
              ? element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][1]?.status
                ? "P"
                : "A"
              : "NA"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Wednesday">
        <th
          [ngStyle]="todaysDay == 3 ? { 'font-weight': '900' } : {}"
          mat-header-cell
          *matHeaderCellDef
        >
          WED <br /><span>{{
            currentWeekReport[2].date | date : "MMM dd"
          }}</span>
        </th>
        <td
          [ngClass]="{
            '': !currentWeekReport[2].valid,
            'a-status':
              !(
                currentWeekReport[2].valid &&
                element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][2]?.status
              ) && currentWeekReport[2].valid,
            'p-status':
              currentWeekReport[2].valid &&
              element.groupedEmployeeAttendanceLogWeeks &&
              element.groupedEmployeeAttendanceLogWeeks[
                numberOfPreviousWeeks - 1
              ][2]?.status
          }"
          [ngStyle]="{
            'font-weight': areDatesEqual(currentWeekReport[2].date)
              ? '900'
              : 'normal',
            'background-color': areDatesEqual(currentWeekReport[2].date)
              ? 'wheat'
              : 'transparent'
          }"
          mat-cell
          *matCellDef="let element"
        >
          {{
            currentWeekReport[2].valid
              ? element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][2]?.status
                ? "P"
                : "A"
              : "NA"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Thursday">
        <th
          [ngStyle]="todaysDay == 4 ? { 'font-weight': '900' } : {}"
          mat-header-cell
          *matHeaderCellDef
        >
          THU <br /><span>{{
            currentWeekReport[3].date | date : "MMM dd"
          }}</span>
        </th>
        <td
          [ngClass]="{
            '': !currentWeekReport[3].valid,
            'a-status':
              !(
                currentWeekReport[3].valid &&
                element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][3]?.status
              ) && currentWeekReport[3].valid,
            'p-status':
              currentWeekReport[3].valid &&
              element.groupedEmployeeAttendanceLogWeeks &&
              element.groupedEmployeeAttendanceLogWeeks[
                numberOfPreviousWeeks - 1
              ][3]?.status
          }"
          [ngStyle]="{
            'font-weight': areDatesEqual(currentWeekReport[3].date)
              ? '900'
              : 'normal',
            'background-color': areDatesEqual(currentWeekReport[3].date)
              ? 'wheat'
              : 'transparent'
          }"
          mat-cell
          *matCellDef="let element"
        >
          {{
            currentWeekReport[3].valid
              ? element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][3]?.status
                ? "P"
                : "A"
              : "NA"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Friday">
        <th
          [ngStyle]="todaysDay == 5 ? { 'font-weight': '900' } : {}"
          mat-header-cell
          *matHeaderCellDef
        >
          FRI <br />
          <span>{{ currentWeekReport[4].date | date : "MMM dd" }}</span>
        </th>
        <td
          [ngClass]="{
            '': !currentWeekReport[4].valid,
            'a-status':
              !(
                currentWeekReport[4].valid &&
                element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][4]?.status
              ) && currentWeekReport[4].valid,
            'p-status':
              currentWeekReport[4].valid &&
              element.groupedEmployeeAttendanceLogWeeks &&
              element.groupedEmployeeAttendanceLogWeeks[
                numberOfPreviousWeeks - 1
              ][4]?.status
          }"
          [ngStyle]="{
            'font-weight': areDatesEqual(currentWeekReport[4].date)
              ? '900'
              : 'normal',
            'background-color': areDatesEqual(currentWeekReport[4].date)
              ? 'wheat'
              : 'transparent'
          }"
          mat-cell
          *matCellDef="let element"
        >
          {{
            currentWeekReport[4].valid
              ? element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][4]?.status
                ? "P"
                : "A"
              : "NA"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Saturday">
        <th
          [ngStyle]="todaysDay == 6 ? { 'font-weight': '900' } : {}"
          mat-header-cell
          *matHeaderCellDef
        >
          SAT <br /><span>{{
            currentWeekReport[5].date | date : "MMM dd"
          }}</span>
        </th>
        <td
          [ngClass]="{
            '': !currentWeekReport[5].valid,
            'a-status':
              !(
                element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][5]?.status
              ) && currentWeekReport[5].valid,
            'p-status':
              element.groupedEmployeeAttendanceLogWeeks &&
              element.groupedEmployeeAttendanceLogWeeks[
                numberOfPreviousWeeks - 1
              ][5]?.status
          }"
          [ngStyle]="{
            'font-weight': areDatesEqual(currentWeekReport[5].date)
              ? '900'
              : 'normal',
            'background-color': areDatesEqual(currentWeekReport[5].date)
              ? 'wheat'
              : 'transparent'
          }"
          mat-cell
          *matCellDef="let element"
        >
          {{
            currentWeekReport[5].valid
              ? element.groupedEmployeeAttendanceLogWeeks &&
                element.groupedEmployeeAttendanceLogWeeks[
                  numberOfPreviousWeeks - 1
                ][5]?.status
                ? "P"
                : "A"
              : "NA"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="FullName">
        <th mat-header-cell *matHeaderCellDef>Full Name</th>
        <td
          mat-cell
          *matCellDef="let element"
          [ngStyle]="
            screenSize !== ScreenType.Mobile
              ? {
                  display: 'flex',
                  'align-items': 'center',
                  'font-weight': '700'
                }
              : {}
          "
        >
          <div class="avatar" *ngIf="screenSize !== ScreenType.Mobile">
            <img [src]="element.profilePictureLink" alt="Profile Image" />
          </div>
          {{ element.firstName + " " + element.lastName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">
          &nbsp;
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            aria-label="expand row"
            (click)="toggleExpandedElement(element, $event)"
          >
            <mat-icon *ngIf="expandedElement === element"
              >keyboard_arrow_up</mat-icon
            >
            <mat-icon *ngIf="expandedElement !== element"
              >keyboard_arrow_down</mat-icon
            >
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="columnsToDisplayWithExpand.length"
          [ngClass]="{
            'employee-element-detail-expanded': getExpandState(element)
          }"
        >
          <div
            class="employee-element-detail"
            [@detailExpand]="getExpandState(element)"
          >
            <div class="employee-profile-picture">
              <img [src]="element.ProfilePictureLink" alt="" />
            </div>
            <!-- Your expanded content goes here -->
            <div class="employee-details">
              <div class="employee-element-sub-detail">
                <b>EmployeeID: </b>{{ element.EmployeeId }}
              </div>
              <div class="employee-element-sub-detail">
                <b>Employee Created:</b>
                {{ element.EmployeeAddDateTime | date }}
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
      <tr
        mat-row
        *matRowDef="let element; columns: columnsToDisplayWithExpand"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="example-detail-row"
      ></tr>
    </table>
  </div>

  <div class="table-bottom">
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-label>Search</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="Search Employee"
        #input
      />
    </mat-form-field>
    <mat-paginator
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      aria-label="Select page of employee"
    ></mat-paginator>
  </div>
</div>
<div
  *ngIf="
    screenSize === ScreenType.Mobile && dataSourceWithIndex.length > 0 && false
  "
  class="employee-detail-mobile-table"
>
  <div class="mobile-table-card-wrapper">
    <div
      *ngFor="let employee of dataSourceWithIndex; let i = index"
      class="mobile-table-card-container"
    >
      <div class="card-content">
        <div>
          Employee ID: <b>{{ employee.employeeId }}</b>
        </div>
        <div>
          Employee Name :
          <b>{{ employee.firstName + " " + employee.lastName }}</b>
        </div>
        <div>
          Phone Number:
          <b>{{ employee.phoneNumber }} </b>
        </div>
        <div>
          Email:
          <b>{{ employee.email }} </b>
        </div>
      </div>
      <div class="card-action">
        <img [src]="employee.profilePictureLink" alt="" />
      </div>
    </div>
  </div>
</div>
<div
  class="employee-details-table-nodata"
  *ngIf="dataSourceWithIndex.length == 0"
>
  No Employee Report
</div>
